<template>
  <div class="header-bar">
    <div class="header">
      <!-- header部分 -->
      <nav class="nav">
        <ul class="navBar">
          <li><router-link to="/home">首页</router-link></li>
          <li><router-link to="/info?id=1">网络相关要求</router-link></li>
          <li><router-link to="/info?id=2">项目架构及研发技术</router-link></li>
          <li><router-link to="/info?id=3">项目特色</router-link></li>
          <li><router-link to="/info?id=4">持续建设服务计划</router-link></li>
          <li><router-link to="/info?id=5">教学引导视频</router-link></li>
          <li><router-link to="/info?id=66">项目申报书</router-link></li>
          <li><router-link to="/team">服务团队</router-link></li>
        </ul>
      </nav>
    </div>                 
  </div>
</template>

<script>
  export default {
    name: 'HeaderBar'
  }
</script>

<style lang="scss" scoped>
</style>
